import axios from 'axios'
import store from '@/store'
import {changeFormShapeIfItIsPhone} from '../class/Converter'
import router from "@/router";
import {toast} from '../class/Notification'

export default {
    namespaced: true,
    state: {
        cellphoneForForgetPassword: null,
        emailForForgetPassword: null,
        formStepOnRegisterWithVerifyPhone: 1
    },
    mutations: {
        setUser(state, user) {
            store.dispatch('User/setUser', user)

        },
        setToken(state, token) {
            store.dispatch('User/setToken', token)
        },
        setCellphoneForForgetPassword(state, phone) {
            state.cellphoneForForgetPassword = phone
        },
        setEmailForForgetPassword(state, email) {
            state.emailForForgetPassword = email
        },
        setFormStepOnRegisterWithVerifyPhone(state, step) {
            state.formStepOnRegisterWithVerifyPhone = step
        }
    },
    actions: {
        login({commit}, form,) {
            form = changeFormShapeIfItIsPhone(form)
            axios.post('/auth/login', form)
                .then(res => {
                    store.dispatch('User/setUserState', res)
                    router.push({name: 'Home'})
                })
                .catch(error => {
                    console.log(error)
                })
        },
        register({commit}, form) {
            axios.post('/auth/register', form).then(res => {
                store.dispatch('User/setUserState', res)
                router.push({name: 'Home'})
            })
                .catch(error => {
                    console.log(error)
                })
        },
        async attemptLogin({commit}) {
            const token = localStorage.getItem('token')

            if (token === null) {
                return
            }

            try {
                let res = await axios.get('/auth/me')
                const profile = res.data.data
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
                store.dispatch('User/setToken', token)
                store.dispatch('User/setProfile', profile)
            } catch (e) {
                localStorage.removeItem('token')
                store.dispatch('User/setToken', null)
                store.dispatch('User/setProfile', null)
                return e
            }

        },
        sendCellPhoneVerificationCode({commit}, form) {
            axios.post('/auth/phone/send/verification', form).then(res => {
                router.push({name: 'VerifiedCellphone'})
                toast(".کد با موفقیت ارسال شد", "کد با موفقیت به شماره تلفن همراه شما ارسال شد");

            })
                .catch(error => {
                    console.log(error)
                })
        },
        verifyCellphone({commit}, form) {
            axios.post('/auth/phone/verified', form).then(res => {
                store.commit('User/setUser', {...store.getters['User/getProfile'], cellphone_verified_at: new Date()})
                router.push({name: 'Profile'})
                toast("شماره تلفن همراه با موفقیت تایید شد.", "شماره تلفن همراه تایید شد");

            })
                .catch(error => {
                    console.log(error)
                })
        },

        resendCellphoneVerificationCode({commit}, form) {
            axios.post('/auth/phone/send/verification', form).then(res => {
                toast(".کد با موفقیت ارسال شد", "کد با موفقیت به شماره تلفن همراه شما ارسال شد");

            }).catch(error => {
                console.log(error)
            })
        },

        sendEmailVerificationCode({commit}, form) {
            axios.post('/auth/email/send/verification', form).then(res => {
                toast(".لینک تایید با موفقیت به ایمیل شما ارسال شد", "لطفا بخش junk یا spam خود را بررسی نمایید");

            })
                .catch(error => {
                    console.log(error)
                })
        },
        verifyEmail({commit}, form) {
            const id = form.id;
            const hash = form.hash
            axios.get(`/auth/email/verified/${id}/${hash}`, form).then(res => {
                store.commit('User/setUser', {...store.getters['User/getProfile'], email_verified_at: new Date()})
                router.push({name: 'Profile'})
                toast("ایمیل با موفقیت تایید شد.", "ایمیل تایید شد");

            })
                .catch(error => {
                    console.log(error)
                })
        },


        logout({commit}) {
            console.log(axios.defaults.headers.common['Authorization'])
            axios.post('/auth/logout')
                .then(res => {
                    console.log(res)
                    store.dispatch('User/setToken', null)
                    store.dispatch('User/setProfile', null)
                    localStorage.removeItem('token')
                    router.push({name: 'Home'})
                })
                .catch(error => {
                    console.log(error)
                })
        },
        cellphoneForgetPassword({commit}, form) {
            axios.post('/auth/cellphone/forgot-password', form).then(res => {
                console.log(res);
                commit('setCellphoneForForgetPassword', form)
                router.push({name: 'CellphoneResetPassword'})
                toast(".کد با موفقیت ارسال شد", "کد با موفقیت به شماره تلفن همراه شما ارسال شد");

            })
                .catch(error => {
                    console.log(error)
                })
        },
        resendCodeForCellphoneForgetPassword({commit}, form) {
            axios.post('/auth/cellphone/forgot-password', form).then(res => {
                commit('setCellphoneForForgetPassword', form)

                console.log(res);
                toast(".کد با موفقیت ارسال شد", "کد با موفقیت به شماره تلفن همراه شما ارسال شد");

            })
                .catch(error => {
                    console.log(error)
                })
        },
        emailForgetPassword({commit}, form) {
            axios.post('/auth/email/forgot-password', form).then(res => {
                console.log(res);
                commit('setEmailForForgetPassword', form)
                toast(".لینک تایید با موفقیت به ایمیل شما ارسال شد", "لطفا بخش junk یا spam خود را بررسی نمایید");

            })
                .catch(error => {
                    console.log(error)
                })
        },
        cellphoneResetPassword({commit}, form) {
            axios.post('/auth/cellphone/reset-password', form).then(res => {
                router.push({name: 'Login'})
                toast(".رمز عبور ثبت شد", "رمز عبور با موفقیت ثبت شد");
            })
                .catch(error => {
                    console.log(error)
                })
        },
        emailResetPassword({commit}, form) {
            axios.post('/auth/email/reset-password', form).then(res => {
                router.push({name: 'Login'})
                toast(".رمز عبور ثبت شد", "رمز عبور با موفقیت ثبت شد");

            })
                .catch(error => {
                    console.log(error)
                })
        },
        verifyCellPhoneBeforeRegister({commit}, form) {
            axios.post('auth/verify-cell-phone-without-register', form)
                .then(res => {
                    commit('setFormStepOnRegisterWithVerifyPhone', 2)
                    toast('کد تایید با موفقیت برای شما ارسال شد', 'کد تایید با موفقیت برای شما ارسال شد');
                })
                .catch(error => {
                    commit('setFormStepOnRegisterWithVerifyPhone', 1)
                    console.log(error)
                })
        },
        registerWithVerifyCellPhone({commit}, form) {
            axios.post('auth/register-after-verify-cell-phone', form)
                .then(res => {
                    commit('setFormStepOnRegisterWithVerifyPhone', 2)
                    store.dispatch('User/setUserState', res)
                    router.push({name: 'Home'})
                    toast('ثبت نام با موفقیت انجام شد', 'رمز عبور برای شما ارسال خواهد شد.');
                })
                .catch(error => {
                    commit('setFormStepOnRegisterWithVerifyPhone', 1)
                    console.log(error)
                })
        },

    },
    getters: {
        getCellphoneForForgetPassword: state => state.cellphoneForForgetPassword,
        getEmailForForgetPassword: state => state.emailForForgetPassword,
        getFormStepOnRegisterWithVerifyPhone: state => state.formStepOnRegisterWithVerifyPhone,
    }
}